import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../../constants/helper";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { ShowTableStok } from "../../../../components/ShowTable";
import { FetchErrorHandling } from "../../../../components/FetchErrorHandling";
import { SearchBar, Loader, ButtonModifier } from "../../../../components";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Box, Pagination, Button, ButtonGroup } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const TampilStok = () => {
  const ref = useRef(null);
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const screenSize = useScreenWidth();

  const [isFetchError, setIsFetchError] = useState(false);
  const [kodeStok, setKodeStok] = useState("");
  const [barcodeStok, setBarcodeStok] = useState("");
  const [namaStok, setNamaStok] = useState("");
  const [merkStok, setMerkStok] = useState("");
  const [satuanKecilStok, setSatuanKecilStok] = useState("");
  const [satuanBesarStok, setSatuanBesarStok] = useState("");
  const [konversiStok, setKonversiStok] = useState("");
  const [hargaJualStok, setHargaJualStok] = useState("");
  const [kodeGroupStok, setKodeGroupStok] = useState("");

  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [stoks, setStoks] = useState([]);
  const [stoksPagination, setStoksPagination] = useState([]);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getStoksPagination();
    id && getStokById();
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [id, page, searchTerm]);

  const getStoksPagination = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/stoksPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      setStoksPagination(response.data.stoks);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getStoks = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/stoks`, {
        _id: user.id,
        token: user.token,
      });
      setStoks(response.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getStokById = async () => {
    if (id) {
      const response = await axios.post(`${tempUrl}/stoks/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setKodeStok(response.data.kodeStok);
      setBarcodeStok(response.data.barcodeStok);
      setNamaStok(response.data.namaStok);
      setMerkStok(response.data.merkStok);
      setSatuanKecilStok(response.data.satuanKecilStok);
      setSatuanBesarStok(response.data.satuanBesarStok);
      setKonversiStok(response.data.konversiStok);
      setHargaJualStok(response.data.hargaJualStok.toLocaleString("de-DE"));
      setKodeGroupStok(
        `${response.data.groupstok.kodeGroupStok} - ${response.data.groupstok.namaGroupStok}`
      );
    }
  };

  const deleteJaminan = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deleteStok/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setSearchTerm("");
      setNamaStok("");
      setMerkStok("");
      setSatuanKecilStok("");
      setSatuanBesarStok("");
      setKonversiStok("");
      setHargaJualStok("");
      setKodeStok("");
      setBarcodeStok("");
      setKodeGroupStok("");

      navigate("/stok");
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(`${namaStok} tidak bisa dihapus karena sudah ada data!`);
      }
    }
    setLoading(false);
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date = formatDate(date);
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(10);
    doc.text(
      `${setting.namaPerusahaan} - ${setting.kabupatenPerusahaan}`,
      15,
      10
    );
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(14);
    doc.text(`Daftar Stok`, 80, 30);
    doc.setFontSize(8);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
      styles: {
        fontSize: 8,
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Stok",
    sheet: "DaftarStok",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container ref={ref}>
      <h3>Master</h3>
      <h5 style={{ fontWeight: 400 }}>Daftar Stok</h5>
      {id && (
        <Box>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/stok")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
        </Box>
      )}
      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getStoks();
              setPreviewPdf(!previewPdf);
              setPreviewExcel(false);
            }}
          >
            PDF
          </Button>
          <Button
            color="secondary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getStoks();
              setPreviewExcel(!previewExcel);
              setPreviewPdf(false);
            }}
          >
            Excel
          </Button>
        </ButtonGroup>
      </Box>
      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="table" id="table">
            <thead>
              <tr>
                <th>Kode</th>
                <th>Barcode</th>
                <th>Nama</th>
                <th>Merk</th>
                <th>S. Kecil</th>
                <th>S. Besar</th>
                <th>Konversi</th>
                <th>Harga Jual</th>
                <th>Group Stok</th>
              </tr>
            </thead>
            <tbody>
              {stoks.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.kodeStok}</td>
                  <td>{user.barcodeStok}</td>
                  <td>{user.namaStok}</td>
                  <td>{user.merkStok}</td>
                  <td>{user.satuanKecilStok}</td>
                  <td>{user.satuanBesarStok}</td>
                  <td>{user.konversiStok}</td>
                  <td>{user.hargaJualStok}</td>
                  <td>
                    {user.groupstok.kodeGroupStok} -{" "}
                    {user.groupstok.namaGroupStok}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table ref={tableRef}>
          {previewExcel && (
            <tbody>
              <tr>
                <th>Kode</th>
                <th>Barcode</th>
                <th>Nama</th>
                <th>Merk</th>
                <th>S. Kecil</th>
                <th>S. Besar</th>
                <th>Konversi</th>
                <th>Harga Jual</th>
                <th>Group Stok</th>
              </tr>
              {stoks.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.kodeStok}</td>
                  <td>{user.barcodeStok}</td>
                  <td>{user.namaStok}</td>
                  <td>{user.merkStok}</td>
                  <td>{user.satuanKecilStok}</td>
                  <td>{user.satuanBesarStok}</td>
                  <td>{user.konversiStok}</td>
                  <td>{user.hargaJualStok}</td>
                  <td>
                    {user.groupstok.kodeGroupStok} -{" "}
                    {user.groupstok.namaGroupStok}
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
      <Box sx={buttonModifierContainer}>
        <ButtonModifier
          id={id}
          kode={id}
          addLink={`/stok/tambahStok`}
          editLink={`/stok/${id}/edit`}
          deleteUser={deleteJaminan}
          nameUser={kodeStok}
        />
      </Box>
      {id && (
        <Container>
          <hr />
          <Form>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={kodeStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Barcode :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={barcodeStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nama :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={namaStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Merk :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={merkStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Satuan Kecil :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={satuanKecilStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Satuan Besar :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={satuanBesarStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Konversi :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={konversiStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Harga Jual :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={hargaJualStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Group :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={kodeGroupStok} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Container>
      )}
      <hr />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableStok currentPosts={stoksPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilStok;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
